import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FdrViewModel } from './claim.model';
import { Global } from '@services/core/Global';
import { QueryUtils } from '../../../../core/utils/query.utils';

@Injectable({
    providedIn: 'root'
})
export class ClaimsManagementService {
    public url: string = Global.url;

    constructor(private _http: HttpClient) { }

    getPeriods(): Observable<any> {
        return this._http.get(this.url + 'V1/periods');
    }

    getFdrAccounts(): Observable<any> {
        return this._http.get(this.url + 'V1/fdr-accounts/');
    }

    updateFdrAccount(params): Observable<any> {
        return this._http.put(this.url + 'V1/fdr-accounts/' + params.id, params);
    }

    saveFdrAccountMovements(params): Observable<any> {
        return this._http.post(this.url + 'V1/fdr-account-movements/', params);
    }

    getStatus(): Observable<any> {
        return this._http.get(this.url + 'V1/status');
    }

    getEntities(): Observable<any> {
        return this._http.get(this.url + 'V1/fpv-entities');
    }

    getParties(params?: FdrViewModel): Observable<any> {
        const httpParams = QueryUtils.convertToFilter(params);
        return this._http.get(this.url + 'V1/claims-view', { params: httpParams });
    }

    // Wrappers para mantener compatibilidad
    protected convertToFilter(objeto) { return QueryUtils.convertToFilter(objeto); }
    protected setTotals(records) { return QueryUtils.setTotals(records); }
    protected applyFilter(records, params) { return QueryUtils.applyFilter(records, params); }
}